(function () {
  if (typeof window === 'undefined') return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  // Selectors to fade up on entering the viewport.
  // Targets the main content blocks of every Thyred section without touching
  // structural chrome (nav, footer, sticky CTA, modals).
  var REVEAL_SELECTORS = [
    '.press-inner > *',
    '.problem-inner > *',
    '.problem .stat',
    '.techblock .wrap > *',
    '.techblock .pillars .p',
    '.how .wrap > *',
    '.how .steps > *',
    '.science .wrap > *',
    '.science .cards > *',
    '.compare .wrap > *',
    '.team .wrap > *',
    '.team .grid > *',
    '.beta-reviews .wrap > *',
    '.beta-reviews .reviews > *',
    '.faq .wrap > *',
    '.faq .faq-list > *',
    '.founder .wrap > *',
    '.founder-inner > *',
    '.pricing-inner > .pr-sticky',
    '.pr-info > *'
  ];

  function init() {
    var nodes = [];
    REVEAL_SELECTORS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        // Skip elements that are already inside a faq accordion answer (kept static)
        if (el.closest('.faq-a')) return;
        nodes.push(el);
      });
    });

    if (!nodes.length) return;

    // Stagger within each direct parent so siblings cascade slightly.
    var parentIndex = new WeakMap();
    nodes.forEach(function (el) {
      var p = el.parentElement;
      var i = parentIndex.get(p) || 0;
      el.style.setProperty('--tr-delay', (Math.min(i, 6) * 70) + 'ms');
      parentIndex.set(p, i + 1);
      el.classList.add('tr-reveal');
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

    nodes.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
